module.exports = __webpack_public_path__ + "static/media/teafloor5.e84d90d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/teafloor5.jpg
// module id = 456
// module chunks = 0